/* global frontendAuthorizerConfig */
import modal from '../components/modal';
import { logError } from '../services/sentryService';
import { sendAdobeData } from '../utils';

const FINISH = {
  init() {
    var inputEdited = false;
    function toggleInputEdited() {
      if (!inputEdited) {
        inputEdited = true;
        newCustomerPassword.off('input', toggleInputEdited);
      }
    }

    const usualCustomerPassword = $('#customerPassword');
    if (usualCustomerPassword) {
      usualCustomerPassword.focus(function () {
        $(this).removeAttr('readonly');
      });
    }

    $('.show-banktransfer-popup a.popup').click(function (e) {
      modal.openThisModal($('.show-banktransfer-boxmodal'), e);
    });

    const newCustomerPassword = $('#newCustomerPassword');

    if (newCustomerPassword) {
      newCustomerPassword.focus(function () {
        $(this).removeAttr('readonly');
      });

      newCustomerPassword.on('input', toggleInputEdited);

      const showPasswordIcon = $('#newShowPassword');
      const hidePasswordIcon = $('#newHidePassword');

      if (showPasswordIcon && hidePasswordIcon) {
        showPasswordIcon.on('click', function () {
          newCustomerPassword.attr('type', 'text');
          showPasswordIcon.addClass('hide');
          hidePasswordIcon.removeClass('hide');
        });

        hidePasswordIcon.on('click', function () {
          newCustomerPassword.attr('type', 'password');
          showPasswordIcon.removeClass('hide');
          hidePasswordIcon.addClass('hide');
        });
      }
    }

    // if we show only article pictures, calculate how many we show based on window width
    const productLists = $('.cart__table__products__list');
    productLists.each(function () {
      const articleImages = $(this).find('.cart__table__image_container');
      const articleCount = articleImages.length;
      if (articleCount) {
        const width = $(window).width();
        const numberOfArticlesToShow = width >= 1024 ? 6 : width >= 544 ? 5 : 4;

        articleImages.each(function (index) {
          if (index < numberOfArticlesToShow) {
            $(this).addClass('visible');

            if (
              index === numberOfArticlesToShow - 1 &&
              articleCount > numberOfArticlesToShow
            ) {
              $(this).html(`+${articleCount - (numberOfArticlesToShow - 1)}`);
            }
          }
        });
      }
    });

    const paymentRetryButtonClickHandler = () => {
      sendAdobeData(
        'customClickTrack',
        'Checkout',
        'Finish Page',
        'Payment Retry button'
      );
    };

    const paymentRetryButton = document.querySelectorAll(
      '[id^="paymentRetry"]'
    );

    paymentRetryButton.forEach((element) => {
      element.addEventListener('click', paymentRetryButtonClickHandler);
    });
  },
  async getKeycloakTokenForAuthorizer() {
    try {
      const { token } = frontendAuthorizerConfig || {};
      if (token) {
        this.setKeycloakTokenAsPropToComponents(token);
        return;
      }

      // Fallback token fetch for Modernized Flow to accommodate components that still need the token
      const response = await fetch(
        '/semiprotected/api/checkout/state-api/v2/token',
        {
          method: 'GET',
          credentials: 'same-origin',
        }
      );

      if (!response.ok) {
        return;
      }

      const newToken = await response.text();
      this.setKeycloakTokenAsPropToComponents(newToken);
    } catch (error) {
      logError(
        `Failed to fetch Keycloak token: ${error?.message || String(error)}`
      );
    }
  },
  setKeycloakTokenAsPropToComponents(keycloakAuthToken) {
    const elements = [
      'autoshipment-offer-box-wrapper',
      'stamp-card-forecast-box-wrapper',
      'bonus-points-forecast-box-wrapper',
    ];

    elements.forEach((id) => {
      const element = document.getElementById(id);
      if (element) {
        element.setAttribute('data-token', keycloakAuthToken);
      }
    });
  },
  expressCheckout() {
    const paymentStatusElement = document.getElementById(
      'expressCheckoutPaymentStatus'
    );

    if (!paymentStatusElement) return;

    if (typeof window.paymentFinished !== 'function') {
      logError('Mobile bridge function "paymentFinished" is missing.');
      return;
    }

    const paymentStatus = paymentStatusElement.dataset.paymentStatus;
    window.paymentFinished({ state: paymentStatus });
  },
};

export default FINISH;
